<template>
  <div class="flex">
    <div class="star-number">{{ riskLevel }}</div>
    <div class="starts">
      <BaseIcon
        v-for="risk in risks"
        :key="risk"
        icon="ic_star"
        height="20"
        width="20"
        class="icon"
      />

      <BaseIcon
        v-if="!isDecimalNumber"
        icon="ic_star_half"
        height="20"
        width="20"
        class="half-star"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { BaseIcon } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    BaseIcon
  }
})
export default class RiskScore extends Vue {
  @Prop({ type: Number, required: true })
  public riskLevel!: number;

  private get risks() {
    if (this.isDecimalNumber) return this.riskLevel;
    else return parseInt(String(this.riskLevel), 10);
  }

  private get isDecimalNumber() {
    return Number.isInteger(this.riskLevel);
  }
}
</script>

<style lang="less" scoped>
.star-number {
  font-size: 22px;
  color: @text-primary;
}

.flex {
  display: flex;
  align-items: center;
}

.flex .starts {
  padding-left: 3px;
}
</style>
